import { enumObjClassNames } from "../constants";
import { Globals } from "./Globals";

export class QSerialSCObject {
  constructor() {
    this.fSourceObj = null;

    this.fSubChartID = null;
    this.fParentSubChartID = null;
    this.fTopDBObjID = null;
    this.fSubChartName = null;
    this.fSubChartFieldID = null;
    this.fOverrideField = false;
    this.fFieldDef = null;
    this.fDataObjIDArr = null;
    this.fIsMaster = false;

    this.fChildIDList = null;
    //this.fRootOrder = null;
  }

  Init(sourceSC) {
    this.fSourceObj = sourceSC;

    this.fSubChartID = sourceSC.fSubChartID;
    this.fParentSubChartID = sourceSC.fParentSubChartID;
    this.fTopDBObjID = sourceSC.fTopDBObjID;
    this.fSubChartName = sourceSC.fSubChartName;
    this.fSubChartFieldID = sourceSC.fSubChartFieldID;
    this.fOverrideField = sourceSC.fOverrideField;
    this.fFieldDef = sourceSC.fFieldDef;
    if (sourceSC.fDataObjIDArr) this.fDataObjIDArr = sourceSC.fDataObjIDArr.slice(0); //attack of the clones
    this.fIsMaster = sourceSC.fIsMaster;

    var nc = sourceSC.ChildCount();
    if (nc > 0) this.fChildIDList = [];
    for (var i = 0; i < nc; i++) {
      var child = sourceSC.GetIndexChild(i);
      var cID = child.GetSubChartID();
      this.fChildIDList.push(cID);
    }
  }

  GetSourceObj() {
    return this.fSourceObj;
  }

  Clone() {
    var c = new QSerialSCObject();

    c.fSourceObj = this.fSourceObj;
    c.fSubChartID = this.fSubChartID;
    c.fParentSubChartID = this.fParentSubChartID;
    c.fTopDBObjID = this.fTopDBObjID;
    c.fSubChartName = this.fSubChartName;
    c.fSubChartFieldID = this.fSubChartFieldID;
    c.fOverrideField = this.fOverrideField;
    c.fFieldDef = this.fFieldDef;
    c.fIsMaster = this.fIsMaster;
    if (this.fDataObjIDArr) c.fDataObjIDArr = this.fDataObjIDArr.slice(0); //attack of the clones

    c.fChildIDList = this.fChildIDList.slice(0);
  }

  Restore() {
    var sourceSC = this.fSourceObj;
    var scMgr = sourceSC.GetSubChartMgr();
    var objDB = scMgr.GetObjDB(); //fObjDB;

    var index = scMgr.GetIndexOfSubChart(sourceSC);
    if (index == -1) return;

    sourceSC.Journal();
    sourceSC.fParentSubChartID = this.fParentSubChartID;
    sourceSC.fTopDBObjID = this.fTopDBObjID;
    sourceSC.fSubChartName = this.fSubChartName;
    sourceSC.fSubChartFieldID = this.fSubChartFieldID;
    sourceSC.fOverrideField = this.fOverrideField;
    sourceSC.fFieldDef = this.fFieldDef;
    //    sourceSC.fNameFieldDef = this.fNameFieldDef;
    sourceSC.fIsMaster = this.fIsMaster;

    var objClass = objDB.GetClassByName(
      Globals._wsMgr.GetDoc()?.IsPositionDocument()
        ? enumObjClassNames.position
        : enumObjClassNames.box
    );
    sourceSC.fTopDBObj = objClass.RetrieveObject(sourceSC.fTopDBObjID);

    if (this.fDataObjIDArr) {
      sourceSC.fDataObjIDArr = JSON.parse(JSON.stringify(this.fDataObjIDArr));
      sourceSC.fDataObjArr = sourceSC.fDataObjIDArr.map(function (a) {
        return objClass.RetrieveObject(a);
      });
    } else {
      sourceSC.fDataObjArr = null;
      sourceSC.fDataObjIDArr = null;
    }

    var parentSC = null;
    var parentID = sourceSC.fParentSubChartID;
    if (parentID != -1) parentSC = scMgr.FindSubChart(parentID);
    sourceSC.fParentSubChart = parentSC;

    sourceSC.fChildren = [];
    if (this.fChildIDList) {
      var n = this.fChildIDList.length;
      for (var i = 0; i < n; i++) {
        var childID = this.fChildIDList[i];
        var childSC = scMgr.FindSubChart(childID);
        sourceSC.fChildren.push(childSC);
        childSC.fParentSubChart = sourceSC;
      }
    }
  }
}
